export default function activitiesTimelineShowMore(index, isShow) {
	this.dataSet("rightPanel/data/records/" + index + "/showAll", isShow);
}